// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sw_a bhk_b bhk_bj","SubscribedPhotoblogs__link":"sw_b bhk_a bhk_r"};